export default __webpack_public_path__ + "static/media/calendar.1f789a38.svg";